export default __webpack_public_path__ + "0d02f9513df3f743fad4ad641055cb31.svg";